import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fadeUp } from "@/lib/motion";

export default function EconomicsSection() {
  return (
    <section
      data-testid="economics-section"
      className="bg-[#faf7f0] text-[#0a1930]"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-24 lg:py-36">
        <motion.div
          {...fadeUp}
          className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-14 lg:mb-16"
        >
          <div className="lg:col-span-4">
            <span className="overline-tag text-[#f26522]">The economics</span>
          </div>
          <div className="lg:col-span-8">
            <h2 className="font-display text-[clamp(2.25rem,4.6vw,4.5rem)] leading-[1.02] tracking-tight max-w-[920px]">
              Compare it to what you already spend to get a customer.
            </h2>
            <p className="mt-6 text-lg text-[#0a1930]/70 leading-relaxed max-w-[680px]">
              You already have a number for what a new customer costs you. Put the
              Free Healthcare Pathway next to it.
            </p>
          </div>
        </motion.div>

        <motion.div
          {...fadeUp}
          className="grid grid-cols-1 lg:grid-cols-12 gap-5 lg:gap-8 items-stretch"
        >
          <div className="lg:col-span-5 border border-[#0a1930]/15 bg-white/40 p-7 lg:p-9">
            <span className="overline-tag text-[#0a1930]/55">
              What you already track
            </span>
            <h3 className="font-display text-[clamp(2rem,3.6vw,3.4rem)] leading-[1.02] mt-5">
              Your acquisition cost.
            </h3>
            <p className="mt-5 text-[#0a1930]/70 leading-relaxed max-w-[440px]">
              Compare the pathway with the customer acquisition number your
              organisation already uses internally.
            </p>
          </div>

          <div className="lg:col-span-2 flex items-center justify-center">
            <span className="font-display-italic text-2xl text-[#0a1930]/45">
              vs.
            </span>
          </div>

          <div className="lg:col-span-5 border border-[#f26522] bg-white/40 p-7 lg:p-9">
            <span className="overline-tag text-[#f26522]">
              Free Healthcare Pathway
            </span>
            <div className="mt-5 flex flex-wrap items-end gap-x-3 gap-y-1">
              <span className="font-display text-[clamp(3rem,5.2vw,5.25rem)] leading-none tracking-tight">
                $3–$5
              </span>
              <span className="pb-2 text-sm text-[#0a1930]/60">
                per customer / month
              </span>
            </div>
            <p className="mt-5 text-[#0a1930]/70 leading-relaxed max-w-[440px]">
              Medicual currently presents the pathway at $3–$5 per customer, per
              month.
            </p>
          </div>
        </motion.div>

        <motion.div
          {...fadeUp}
          className="mt-12 pt-8 border-t border-[#0a1930]/15 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6"
        >
          <p className="text-[#0a1930]/65 max-w-[620px]">
            A concrete healthcare benefit, set beside an acquisition cost you
            already understand.
          </p>
          <Link
            to="/contact"
            className="group inline-flex items-center gap-3 overline-tag text-[#f26522] hover:text-[#0a1930] transition-colors"
          >
            Discuss your market
            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
